<!-- Etapas y fases -->
<div class="content" *ngIf="!this.loading">
  <!-- Etapas -->
  <div class="content__stages">
    <div class="content__title">
      <p>Etapas</p>
      <qr-button
        [config]="this.buttonAdd"
        (click)="onAddStage()"
        [isDisabled]="this.stages.length >= 10"
      ></qr-button>
    </div>
    <div class="content__info">
      <p>
        El proceso de reclutamiento debe tener entre 3 y 10 etapas para asegurar
        una selección organizada de los candidatos.
      </p>

      <p id="error-message" *ngIf="this.hasError">
        Atención: Posee etapas sin fases asociadas. Las mismas no podran ser
        usadas en el panel hasta que no tengan al menos una fase.
      </p>
    </div>
    <div
      class="content__wrapper"
      cdkDropList
      (cdkDropListDropped)="dropStage($event)"
    >
      <div
        cdkDrag
        class="stage"
        *ngFor="let stage of this.stages; let i = index"
        [class.stage--selected]="stage.selected"
        [class.stage--error]="stage.hasError"
        (click)="onSelectionStage(stage.id)"
        [cdkDragDisabled]="i == 0 || i == this.stages.length - 1"
      >
        <div class="stage__info">
          <div class="stage__order">
            <p>{{ i + 1 }}</p>
          </div>
          <tag-stage-phase class="card__phase" [type]="stage.hierarchy">{{
            stage.name
          }}</tag-stage-phase>
        </div>
        <div
          class="stage__actions"
          *ngIf="i != 0 && i != this.stages.length - 1"
        >
          <qr-button
            [config]="buttonEdit"
            (click)="onEditStage(stage, $event)"
            matTooltip="Editar"
            class="btn"
          ></qr-button>
          <qr-button
            [config]="buttonDelete"
            matTooltip="Borrar"
            (click)="onDeleteStage(stage, $event)"
          ></qr-button>
        </div>
      </div>
    </div>
  </div>
  <!-- Etapas END -->
  <!-- Fases -->
  <div class="content__phases">
    <div class="content__title">
      <p>Fases</p>
      <qr-button
        [config]="this.buttonAdd"
        [isDisabled]="
          this.blockPhaseEdit ||
          this.phaseList.length >= 5 ||
          (this.phaseList.length == 0 && !this.hasStageSelected)
        "
        (click)="onAddPhase()"
      ></qr-button>
    </div>
    <div class="content__info">
      <p>
        Cada etapa del reclutamiento debe incluir entre 1 y 5 fases para una
        evaluación detallada de los candidatos.
      </p>
    </div>
    <div
      class="content__wrapper"
      cdkDropList
      (cdkDropListDropped)="dropPhase($event)"
    >
      <div
        class="phase"
        *ngFor="let phase of this.phaseList; let i = index"
        cdkDrag
      >
        <div class="phase__info">
          <div class="stage__order">
            <p>{{ i + 1 }}</p>
          </div>
          <tag-stage-phase class="card__phase" [type]="phase.hierarchy">{{
            phase.name
          }}</tag-stage-phase>
        </div>
        <div class="phase__actions" *ngIf="!this.blockPhaseEdit">
          <qr-button
            [config]="buttonEdit"
            matTooltip="Editar"
            (click)="onEditPhase(phase, $event)"
            class="btn"
          ></qr-button>
          <qr-button
            [config]="buttonDelete"
            (click)="onDeletePhase(phase, $event)"
            matTooltip="Borrar"
          ></qr-button>
        </div>
      </div>
    </div>
  </div>
  <!-- Fases END -->
</div>

<!-- Dialogo acciones -->
<ng-container *ngIf="this.isOverlayVisible">
  <qr-overlay [(isOverlayVisible)]="isOverlayVisible" [config]="overlay">
    <div class="dialog">
      <qr-overlay-topbar (close)="isOverlayVisible = false">{{
        this.dialogTitle
      }}</qr-overlay-topbar>
      <div
        class="dialog__container"
        [ngSwitch]="true"
        [ngClass]="{
          add: this.dialogAction == this.ACTION_ADD,
          edit: this.dialogAction == this.ACTION_EDIT,
          delete: this.dialogAction == this.ACTION_DELETE
        }"
      >
        <ng-container *ngSwitchCase="this.dialogAction == this.ACTION_ADD">
          <p>Nombre</p>
          <div class="dialog__input">
            <qr-input
              [config]="inputAdd"
              (keydown)="onKeyDown($event)"
              [value]="this.itemName"
              (valueChange)="changeInputAdd($event)"
            ></qr-input>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="this.dialogAction == this.ACTION_EDIT">
          <p>Nombre</p>
          <div class="dialog__input">
            <qr-input
              [config]="inputAdd"
              [value]="this.itemName"
              (keydown)="onKeyDown($event)"
              (valueChange)="changeInputAdd($event)"
            ></qr-input>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="this.dialogAction == this.ACTION_DELETE">
          <p>
            ¿Está seguro que desea eliminar la
            {{ this.dialogTitle.includes("etapa") ? "etapa" : "fase" }}
            <strong>{{ this.stageName }}</strong
            >? Esta acción será irreversible.
          </p>
          <div *ngIf="this.hasCandidates" class="dialog__candidates">
            <p>
              Tiene candidatos activos en la
              {{
                this.dialogTitle.includes("etapa")
                  ? "etapa. Selecciona la etapa a la que deseas moverlos."
                  : "fase. Selecciona la fase a la que deseas moverlos"
              }}.
            </p>
            <div class="dialog__dropdowns">
              <div
                class="dialog__stages"
                *ngIf="this.dialogTitle.includes('etapa')"
              >
                <p>Etapa</p>
                <qr-dropdown
                  [config]="dropdownStages"
                  [selected]="this.stageName"
                  (change)="dropdownStagesChange($event)"
                ></qr-dropdown>
              </div>
              <div
                class="dialog__phases"
                *ngIf="
                  this.dialogTitle.includes('fase') ||
                  (this.dialogTitle.includes('etapa') &&
                    this.stageName != this.itemName)
                "
              >
                <p>Fase</p>
                <qr-dropdown
                  [selected]="this.phaseName"
                  [config]="dropdownPhases"
                  (change)="dropdownPhasesChange($event)"
                ></qr-dropdown>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="dialog__actions">
        <qr-button
          [config]="buttonDialogCancel"
          (click)="this.isOverlayVisible = false"
        ></qr-button>

        <qr-button
          *ngIf="this.dialogAction == this.ACTION_DELETE; else buttonsave"
          [config]="buttonDialogDelete"
          (click)="onSave()"
          [isDisabled]="
            this.hasCandidates &&
            (this.itemName == this.stageName ||
              this.itemName == this.phaseName ||
              (this.dialogTitle.includes('etapa') &&
                !this.phaseForTransferName))
          "
        >
        </qr-button>

        <ng-template #buttonsave>
          <qr-button
            [config]="buttonDialogSave"
            [isDisabled]="!this.itemName"
            (click)="onSave()"
          ></qr-button>
        </ng-template>
      </div>
    </div>
  </qr-overlay>
</ng-container>
